import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import DrawSvgPlugin from '../vendor/DrawSVGPlugin.js'

gsap.registerPlugin(DrawSvgPlugin)
gsap.registerPlugin(ScrollTrigger)

export default () => {
    gsap.fromTo('.ceo-svg path', {
        drawSVG: '0%',
    },
    {
        drawSVG: '100%',
        duration: 5,
        ease: 'none',
        scrollTrigger: {
            trigger: '.ceo-svg',
        },
    })
}
